<div class="card">
  <div class="back-nav">
    <button mat-stroked-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Administration Centre de Compétence
    </button>
  </div>

  <app-feb-location-form
    *ngIf="authenticationService.isUserAdmin()"
    [localisation]="localisationSelected"
    (updateEvent)="updateLocalisationList($event)"
    (clearEvent)="initLocalisation()">
  </app-feb-location-form>

  <div class="data-header">
    <mat-form-field class="localisationFilter">
      <mat-label>Filtre</mat-label>
      <input matInput (keyup)="localisationsFilter($event)">
    </mat-form-field>
     <button mat-raised-button (click)="exportData()" class="indigo"
      [style.background-color]="theme.getColor('Main Dark')">
      <mat-icon>get_app</mat-icon>
      Export Excel
    </button>
  </div>

  <mat-table #table class="mat-elevation-z8 table-container" *ngIf="localisations" [dataSource]="localisations" matSort>

    <ng-container matColumnDef="localisationLabel">
      <mat-header-cell *matHeaderCellDef mat-sort-header id="localisationLabel">Localisation</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.localisationLabel }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef id="actions" class="actions-td">Actions</mat-header-cell>
      <mat-cell *matCellDef="let element" class="actions-td">
        <button mat-icon-button (click)="selectedLocalisationPencil(element)" [disabled]="!authenticationService.isUserAdmin()">
          <mat-icon>mode_edit</mat-icon>
        </button>
        <button mat-icon-button (click)="removeLocalisation(element)" [disabled]="!authenticationService.isUserAdmin()">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>
    <mat-row mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
</div>
